module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Annunciator.js"));
	}, "Annunciator");
}